exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reservation-expansion-panel {\n     padding: 0;\n}\n.v-expansion-panel-content__wrap { \n    padding: 0;\n}\n.expansion-panel__header {\n    padding: 0;\n}\n.v-card__text {\n    padding: 0 !important;\n}\n\n/* Highlight those records which urgently need a response from the hotelier */\n.response-overdue {\n    /*background-color: #FFFABD !important; pale yellow */\n    background-color: #C1CD23 !important;\n}\n.circle-icon {\n    height: 25px;\n    width: 25px;\n    border-radius: 50%;\n    display: inline-block;\n}\n", ""]);

// exports
